<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T14:07:39+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-17T20:21:12+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div class="card contextCard">
        <section>
            <div v-if="canShow(['admin','client_admin'])" class="contextButton bottomBorder" @click="$emit('action', 'distribute')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-truck"></i>
                Distribute
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin'])" class="contextButton bottomBorder" @click="$emit('action', 'flag')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-flag"></i>
                Flag
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin'])" class="contextButton bottomBorder" @click="$emit('action', 'duplicate')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-copy"></i>
                Duplicate
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin'])" class="contextButton bottomBorder" @click="$emit('action', 'stats')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-chart-line"></i>
                Stats
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin','client_admin'])" class="contextButton bottomBorder" @click="$emit('action', 'edit')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-pen"></i>
                Edit
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin','client_admin','client'])" class="contextButton bottomBorder" @click="$emit('action', 'view')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-eye"></i>
                View
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin','client_admin'])" class="contextButton bottomBorder" @click="$emit('action', 'rename')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-edit"></i>
                Rename
            </div>
            <!-- ************************************************************************************ -->
            <div v-if="canShow(['admin','client_admin'])" class="contextButton bottomBorder" @click="showDeleteDialog">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-trash"></i>
                Delete
            </div>
            <!-- ************************************************************************************ -->
            <div class="contextButton contextClose" @click="$emit('close')">
                <i style="text-align: center;width: 1rem;" class="dropIcon me-1 fas fa-times-circle"></i>
                Close
            </div>
        </section>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import { sopState, sopMethods } from '@/state/helpers'
export default {
    data:() => ({}),
    computed:{
        ...sopState,
        current_user_role(){
            // admin, client_admin, client
            return this.$store.getters['clientAdmin/userType'];
        }
    },
    methods:{
        ...sopMethods,
        // returns true/false if the current user role can view the context menu item
        //canShow(required_role_string){
        //    let required_roles = required_role_string.split(',');
        //    return required_roles.includes(this.current_user_role);
        //},
        canShow(role){
            if(Array.isArray(role)){
                let found = role.find( item => {
                    return item === this.current_user_role;
                })
                return found ? true : false;
            }
            else{
                return role === this.current_user_role;
            }
        },
        showDeleteDialog(){
            Swal.fire({
                title: 'Delete Document?',
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, delete it!"
            }).then(result => {
                if (result.value) {
                    this.$emit('action', 'delete');
                }
            });
        },
    },
}
</script>

<style>
.bottomBorder{
    border-bottom: 1px solid rgb(59, 59, 59);
}
.contextCard{
    box-shadow: rgb(0 0 0 / 18%) 0px 16px 48px 0px;
    width: 8rem;
    border: 1px solid green !important;
}
.contextButton{
    padding: 0.6rem;
    /*font-family: Roboto;*/
    font-style: normal;
    font-weight: normal;
    font-size: 0.8rem;
}
.contextButton:hover{
    border-radius: 0.2rem;
    cursor: pointer;
    color: #FFFFFF;
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #05B15F 0%, #019750 100%);
}
.contextClose{
    padding: 0.6rem;
    /*font-family: Roboto;*/
    font-style: normal;
    font-weight: normal;
    font-size: 0.8rem;
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #e69705 0%, #ffd000 100%);
}

</style>
